var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{class:[
    _vm._.banner,
    _vm.theme.position === 'left'
      ? _vm._.indicatorLeft
      : _vm.theme.position === 'right'
      ? _vm._.indicatorRight
      : _vm.undefind ],attrs:{"autoplay":5000}},_vm._l((_vm.data),function(item,index){return _c('van-swipe-item',{directives:[{name:"track",rawName:"v-track",value:({
      name: '轮播',
      id: 'DianJiZiDingYiYeZiYuan',
      resource: item,
      index: index,
      extra: _vm.getTrackExtra(item, index),
    }),expression:"{\n      name: '轮播',\n      id: 'DianJiZiDingYiYeZiYuan',\n      resource: item,\n      index: index,\n      extra: getTrackExtra(item, index),\n    }"}],key:index,class:_vm._.item,on:{"click":function($event){return _vm.$dmbcResourceClick(item)}}},[_c('van-image',{class:_vm._.image,attrs:{"src":item.icon}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }